'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('UserCtrl', UserCtrl);

  UserCtrl.$inject = ['Auth', 'User', 'users', 'Constants', '$mdDialog', 'errorMessageService', 'Labels',
    'allProjects', '$filter'];

  function UserCtrl (Auth, User, users, Constants, $mdDialog, errorMessageService, Labels,
    allProjects, $filter) {
    const vm = this;

    vm.userRoles = Constants.getList('USER_ROLES');
    vm.userStatus = Constants.getList('USER_STATUS');
    vm.LABELS = Labels;
    vm.users = users;
    const currentUser = Auth.getCurrentUser();
    vm.currentUserAccessLevel = Auth.getUserAccessLevel();

    const update = () => {
      setUserProjects();
      setUserRoles();
      setUserTenants();

      vm.basicUserData = {
        userLanguage: currentUser.userLanguage,
        databases: [currentUser.databases[0]]
      };
      // copy the references (you could clone ie angular.copy but then have to go through
      // a dirty checking for the matches)
      vm.displayedUsers = [].concat(vm.users);
    };

    vm.deleteConfirmation = (user) => {
      const confirmDelete = $mdDialog.confirm()
        .clickOutsideToClose(true)
        .title(vm.LABELS.getLabel('deactivateuser'))
        .textContent(`${user.fullName} zal hierna geen toegang meer hebben tot SpecsGuard.`)
        .ok(vm.LABELS.getLabel('deactivate'))
        .cancel(vm.LABELS.getLabel('cancel'));

      $mdDialog.show(confirmDelete)
        .then(function () {
          return deleteUser(user);
        }).catch(() => {});
    };

    vm.reactivateConfirmation = (user) => {
      const confirmReactivate = $mdDialog.confirm()
        .clickOutsideToClose(true)
        .title(vm.LABELS.getLabel('reactivateuser'))
        .textContent(`${user.fullName} zal hierna wederom toegang hebben tot SpecsGuard.`)
        .ok(vm.LABELS.getLabel('reactivate'))
        .cancel(vm.LABELS.getLabel('cancel'));

      $mdDialog.show(confirmReactivate)
        .then(function () {
          return reactivateUser(user);
        }).catch(() => {});
    };

    vm.activationLinkConfirmation = (user) => {
      const confirmActivationLink = $mdDialog.confirm()
        .clickOutsideToClose(true)
        .title(vm.LABELS.getLabel('sendactivationlink'))
        .textContent(`Op de volgende e-mail sturen wij instructies om het wachtwoord
          opnieuw in te stellen ${user.email}`)
        .ok(vm.LABELS.getLabel('send'))
        .cancel(vm.LABELS.getLabel('backtooverview'));

      $mdDialog.show(confirmActivationLink)
        .then(function () {
          resendActivationMail(user);
        }).catch(() => {});
    };

    vm.userModal = (ev, user, type) => {
      $mdDialog.show({
        controller: 'UserDetailsCtrl',
        controllerAs: 'AddUserDetailsCtrl',
        templateUrl: 'app-legacy/user/details/user-detail-dialog.tmpl.html',
        targetEvent: ev,
        locals: {
          user: !user ? vm.basicUserData : user,
          modalType: type ? type : 'edit',
        },
        resolve: {
          tenants: [() => User.tenants().$promise]
        }
      })
        .then((updatedUsers) => {
          vm.users = updatedUsers;
          update();
        })
        .catch(() => {});
    };

    vm.columnClickHandler = ($event, user) => {
      const filteredUser = vm.displayedUsers.find((u) => u._id === user);

      // I need the $event to set initialise the userModal()
      // Trigger the userModal()
      vm.userModal($event, filteredUser, 'edit');
    };

    vm.submitNewUserRole = (updatedUserRole) => {
      // The updateUser object will contain the params needed to update an user accordingly
      const originalUser = vm.displayedUsers.find((u) => u._id === updatedUserRole._id);
      const updateUser = {_id: originalUser._id, user: originalUser};

      return User.update(updateUser).$promise.then((usr) => {
        const user = usr.find((u) => u._id === updateUser._id);
        const fullName = user.nameFirst + ' ' + (user.nameInfix || '') + ' ' + user.nameLast;
        errorMessageService.showSuccess(vm.LABELS.getLabelPlaceholder('userroleupdated', {fullname: fullName}));
        return usr.role = updateUser.user.role;
      });
    };

    vm.close = () => {
      closeDialog();
    };

    const closeDialog = () => {
      $mdDialog.hide();
    };

    const deleteUser = (removedUser) =>
      User.remove({ id: removedUser._id }).$promise
        .then(() => {
          errorMessageService.showInfo('De gebruiker ' + removedUser.fullName + 'is zojuist verwijderd');
          vm.displayedUsers.forEach(function (u) {
            if (u === removedUser) {
              u.active = false;
              u.userStatus = 'gedeactiveerd';
            }
          });
        });

    const reactivateUser = (user) =>
      User.update({
        _id: user._id,
        user: Object.assign({}, user, { active: true })
      }).$promise
        .then(() => {
          errorMessageService.showInfo('De gebruiker ' + user.fullName + 'is geactiveerd');
          vm.displayedUsers.forEach(function (u) {
            if (u === user) {
              u.active = true;
              u.userStatus = u.activated ? 'actief' : 'niet geactiveerd';
            }
          });
        });

    const resendActivationMail = (user) => {
      Auth.reactivateUser(user._id)
        .then(() => {
          errorMessageService.showSuccess('Email verstuurd!');
        })
        .catch((error) => {
          errorMessageService.showError(error);
        });
    };

    const setUserRoles = () => {
      vm.users.forEach((user) => {
        user.userRole = Constants.getList('USER_ROLES').find((uRole) => uRole.value === user.role);
        user.accessLevel = user.userRole ? user.userRole.accessLevel : 0;
      });
    };

    // used to filter on users without projects
    const noProjectsProject = {
      name: vm.LABELS.getLabel('projectnotfound'),
      selected: true,
    };

    const setUserProjects = () => {
      let allProjectsArray = [];
      vm.users.forEach((user) => {
        user.projects = [];
        allProjects.forEach((project) => {
          // ignore archived projects
          if (!project.archived && project.active) {
            project.users.forEach((pUser) => {
              if (pUser.projectRole === 'manager') {
                allProjectsArray.push(project);
              }
              if (pUser.userId && pUser.userId._id === user._id) {
                user.projects.push(project.name);
              }
            });
          }
        });

        if (!user.projects.length) {
          user.projects.push(noProjectsProject.name);
          allProjectsArray.push(noProjectsProject);
        }

        user.projectsHoverString = user.projects.join(', ');
        user.projectsString = user.projects.slice(0, 3).join(', ');

        if (user.projects.length > 3) {
          user.projectsString += '...';
        } else if (!user.projects.length) {
          user.projectsString += vm.LABELS.getLabel('projectnotfound');
        }
      });

      vm.allProjectsArray = Array.from(new Set(allProjectsArray));
    };

    /**
     * setUserTenants
     *
     */
    const setUserTenants = () => {
      vm.users.forEach((user) => {
        if (angular.isDefined(user.databases) && angular.isArray(user.databases)) {
          user.databasesString = user.databases.join(', ');

          // let's show a max of 5 db's
          if (user.databases.length > 3) {
            user.databasesString += '...';
          } else if (!user.databases.length) {
            user.databasesString += 'geen werkomgevingen';
          }
        }
      });
    };

    // we cannot use vm.$onInit here because it clashes with vm.tableColumns
    update();

    vm.filterProjects = (column, user) =>
      column.filterData.some((item) => item.selected && user.projects.includes(item.name));

    const filterUserStatus = (columnObj, user) => {
      if (columnObj.value === 'ACTIVE') {
        return user.active && user.activated;
      } else if (columnObj.value === 'DEACTIVATED') {
        return (!user.activated && !user.active) || (user.activated && !user.active);
      } else if (columnObj.value === 'NOT_ACTIVATED') {
        return (user.active && !user.activated);
      }

      return true;
    };
    
    function getProjectDate (id, item, column) {
      if (angular.isDefined(item)) {
        return item['readable' + column.displayKey + 'Date'] = 
        angular.isDefined(item[column.displayKey]) ? $filter('sgDateAgo')(item[column.displayKey]) : ''; 
      }
      return item;
    }

    vm.tableColumns = [{
      headerTitle: vm.LABELS.getLabel('user'),
      type: 'string',
      sortable: true,
      filterData: vm.displayedUsers,
      displayKey: 'fullName',
      template: 'app-legacy/user/user-table-templates/user.avatar.template.html',
      columnClickHandler: vm.columnClickHandler,
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('email'),
      type: 'string',
      sortable: true,
      template: 'app-legacy/user/user-table-templates/user.email.template.html',
      filterData: vm.displayedUsers,
      displayKey: 'email',
      columnClickHandler: vm.columnClickHandler,
      optionValueKey: 'value',
      optionDisplayKey: 'displayName',
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('userrole'),
      type: 'multiSelect',
      sortable: true,
      template: 'app-legacy/user/user-table-templates/user.userrole.template.html',
      filterData: vm.userRoles,
      displayKey: 'role',
      optionValueKey: 'value',
      optionDisplayKey: 'displayName',
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('status'),
      type: 'radio',
      sortable: true,
      template: 'app-legacy/user/user-table-templates/user.status.template.html',
      filterData: vm.userStatus,
      displayKey: 'userStatus',
      optionValueKey: 'value',
      optionDisplayKey: 'displayName',
      customFilter: filterUserStatus,
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getPlural('userconnectedtoprojects'),
      sortable: 'true',
      type: 'multiSelect',
      filterData: vm.allProjectsArray,
      optionDisplayKey: 'name',
      optionValueKey: 'name',
      hoverKey: 'projectsHoverString',
      displayKey: 'projectsString',
      customFilter: vm.filterProjects,
      columnFilter: false,
    }, {
      headerTitle: vm.LABELS.getPlural('userconnectedtotenants'),
      hoverKey: 'databasesString',
      sortable: true,
      displayKey: 'databasesString',
      columnClickHandler: vm.columnClickHandler,
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('dateadded'),
      type: 'date',
      sortable: true,
      displayKey: 'created',
      displayKeyFn: getProjectDate,
      columnClickHandler: vm.columnClickHandler,
      tdClass: 'sg-mat-table__cell--created-date sg-mat-table__cell--timestamp', // needed to define a proper width on the table cell
      columnFilter: false,
    }, {
      headerTitle: vm.LABELS.getLabel('lastactivationmail'),
      type: 'date',
      sortable: true,
      displayKey: 'lastActivationMail',
      displayKeyFn: getProjectDate,
      columnClickHandler: vm.columnClickHandler,
      tdClass: 'sg-mat-table__cell--created-date sg-mat-table__cell--timestamp', // needed to define a proper width on the table cell
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('dateupdated'),
      type: 'date',
      sortable: true,
      displayKey: 'updated',
      displayKeyFn: getProjectDate,
      columnClickHandler: vm.columnClickHandler,
      tdClass: 'sg-mat-table__cell--created-date sg-mat-table__cell--timestamp', // needed to define a proper width on the table cell
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getPlural('option'),
      tdClass: 'sg-mat-table__cell--options sg-mat-table__cell--align-right',
      thClass: 'sg-mat-table__cell--options sg-mat-table__cell--align-right',
      template: 'app-legacy/user/user-table-templates/user.options.template.html',
      columnFilter: true,
    }];

    // this should be always be enabled to use the filter menu
    vm.columnFilters = {
      enabled: true,
    };

    vm.pagination = {
      resultLimitDropdown: {
        enabled: true,
        limit: [10, 20, 50, 100, 250]
      },
      resultLimit: 10
    };
  }

})();
